module.exports = __webpack_public_path__ + "v1.0.0/img/logo.f321fdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/style/images/logo.png
// module id = iCER
// module chunks = 1